import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges
} from "@angular/core";

@Component({
  selector   : 'list-box',
  styles: [ require('./list-box.component.scss') ],
  template: require('./list-box.component.html')
})
export class ListBoxComponent {
  @Input() icon        : string;
  @Input() iconField   : string;
  @Input() items       : Array<any> | any;
  @Input() labelField  : string;
  @Input() multiSelect : boolean;
  @Input() placeholder : string;
  @Input() title       : string;

  @Output() onSelect : EventEmitter<any> = new EventEmitter();

  ngOnChanges ( changes: SimpleChanges ) : void {
    if ( !this.multiSelect && changes?.items?.currentValue?.length ) {
      const selected = changes.items.currentValue.filter(item => item.selected);

      if (selected.length) {
        this.handleSelect(selected[0]);
      }
    }
  }

  handleSelect ( item : any ) : void {
    if ( !this.multiSelect ) {
      if ( Array.isArray(this.items) ) {
        for ( let i = 0; i < this.items.length; i++ ) {
          this.items[i].selected = false;
        }
      }
      else {
        for ( const key in this.items ) {
          this.items[key].selected = false;
        }
      }
    }

    item.selected = !item.selected;

    this.onSelect.emit(item);
  }

  hasItems () : boolean {
    if ( !this.items ) {
      return false;
    }

    return Array.isArray(this.items)
      ? !!this.items.length
      : !!Object.keys(this.items).length;
  }
}